(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemManageTranslations", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/settings/general/languages/learningItems/learningItemManageTranslationsView.html",
            controller: ["authService", "learningItemTypeResource", "localizationResource", "notify", "learningItemTranslationsService", "$compile", "$localStorage", "$sessionStorage", "_", "$timeout", "$scope", "$state", "$translate", "DTOptionsBuilder", "$uibModal", LearningItemManageTranslationsCtrl],
            controllerAs: "vm"
        };
        function LearningItemManageTranslationsCtrl(authService, learningItemTypeResource, localizationResource, notify, learningItemTranslationsService, $compile, $localStorage, $sessionStorage, _, $timeout, $scope, $state, $translate, DTOptionsBuilder, $uibModal) {
            var vm = this;
            vm.lang = $translate.proposedLanguage() || $translate.use();
            vm.dtInstances = [];
            vm.exportSelectedToCsv = exportSelectedToCsv;
            vm.exportNeedsTranslationToCsv = exportNeedsTranslationToCsv;
            vm.itemChecked = itemChecked;
            vm.updateAllCheckBoxes = updateAllCheckBoxes;
            vm.openImportModal = openImportModal;
            vm.dtInstance = {};
            vm.otherLangauagesCount = [];
            vm.learningItemTypes = [];
            vm.enabledLanguages = [];
            vm.selectedRows = [];
            learningItemTypeResource.query(function (data) {
                vm.learningItemTypes = data;
            });
            function openImportModal() {
                var $modalInstance = $uibModal.open({
                    templateUrl: "app/settings/general/languages/learningItems/learningItemTranslationsImportFileModal.html",
                    controller: "LearningItemTranslationsImportFileModalCtrl as vm"
                });
                $modalInstance.result.then(function () {
                    vm.dtInstance.reloadData();
                }).catch(angular.noop);
            }
            localizationResource.query({ action: "tenantEnabled" }, function (data) {
                vm.enabledLanguages = data;
                vm.enabledLanguages = _.reject(vm.enabledLanguages, { localizationId: $localStorage.tenantSettings.defaultLocalization.id });
                vm.enabledLanguages.checked = false;
            });
            function exportSelectedToCsv() {
                $timeout(function () {
                    var checkedLearningItems = _.pluck(_.where(vm.selectedRows, { status: true }), "item");
                    if (checkedLearningItems.length === 0) {
                        notify({ messageTemplate: "<span>{{ 'common.selectLearningItem' | translate }}</span>", classes: "alert-warning", duration: 2000 });
                    }
                    else {
                        var learningItemCodes = _.pluck(checkedLearningItems, "code");
                        vm.enabledLanguages = _.reject(vm.enabledLanguages, { localizationId: $localStorage.tenantSettings.defaultLocalization.id });
                        var enabledLanguageCultures = _.pluck(vm.enabledLanguages, "languageCulture");
                        _.each(enabledLanguageCultures, function (cultureName) {
                            learningItemTranslationsService.exportSelectedToCsv(learningItemCodes, cultureName).then(function (response) {
                                var date = new Date();
                                var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
                                var blob = new Blob([response.data]);
                                window.saveAs(blob, "LearningItemTranslations." + dateString + "." + cultureName + ".csv");
                            }, function () {
                                notify({ messageTemplate: "<span>{{ 'common.genericError' | translate }}</span>", classes: "alert-danger" });
                            });
                        });
                    }
                    resetTheSelectedRows();
                });
            }
            function exportNeedsTranslationToCsv() {
                var enabledLanguageCultures = _.pluck(vm.enabledLanguages, "languageCulture");
                _.each(enabledLanguageCultures, function (cultureName) {
                    learningItemTranslationsService.exportNeedsTranslationToCsv(cultureName).then(function (response) {
                        var date = new Date();
                        var dateString = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " + date.getHours() + "-" + date.getMinutes() + "-" + date.getSeconds();
                        var blob = new Blob([response.data]);
                        window.saveAs(blob, "LearningItemTranslations." + dateString + "." + cultureName + ".csv");
                    }, function () {
                        notify({ messageTemplate: "<span>{{ 'common.genericError' | translate }}</span>", classes: "alert-danger" });
                    });
                });
            }
            //click event for the select all check box:
            //updates the internal datastructure vm.selectedRows
            //with the new value
            function updateAllCheckBoxes() {
                for (var id in vm.selectedRows) {
                    if (vm.selectedRows.hasOwnProperty(id)) {
                        if ($("#" + id).is(":visible")) {
                            vm.selectedRows[id]["status"] = vm.selectAll;
                        }
                    }
                }
            }
            //This the click event on the check box of a single row
            //If any of the rows is NOT checked then set the select all
            //model (vm.selectAll) to false; otherwise set it to true
            function itemChecked() {
                var items = _.where(vm.selectedRows, { status: false });
                vm.selectAll = items.length < 1;
                //$scope.$apply();
            }
            if ($sessionStorage.manageLearningItemTranslationsFilters) {
                vm.filters = $sessionStorage.manageLearningItemTranslationsFilters;
            }
            else {
                vm.filters = {
                    itemName: { enabled: true, value: "" },
                    itemCode: { enabled: false, value: "" },
                    itemType: { enabled: true, value: [] },
                    needTranslation: { enabled: true, value: [] }
                };
            }
            function resetTheSelectedRows() {
                for (var key in vm.selectedRows) {
                    if (vm.selectedRows.hasOwnProperty(key)) {
                        vm.selectedRows[key]["status"] = false;
                    }
                }
                vm.selectAll = false; //clear the select all check box
                $scope.$apply();
            }
            function reloadDataCallback(json) {
                vm.selectedRows = [];
                for (var index in json.data) {
                    if (json.data.hasOwnProperty(index)) {
                        vm.selectedRows[json.data[index]["id"]] = {
                            "status": false,
                            "item": json.data[index]
                        };
                    }
                }
                vm.selectAll = false; //clear the select all check box
                $scope.$apply();
            }
            vm.reloadTable = function () {
                $timeout(function () {
                    $sessionStorage.manageLearningItemTranslationsFilters = vm.filters;
                    vm.dtInstance.reloadData(reloadDataCallback, true);
                });
            };
            vm.refreshFilter = function (value) {
                $sessionStorage.manageLearningItemTranslationsFilters = vm.filters;
                // reload only if filtered
                if (value.length > 0)
                    vm.dtInstance.reloadData();
            };
            vm.closeFilter = function (filter) {
                vm.filters[filter].enabled = false;
                vm.refreshFilter(vm.filters[filter].value);
            };
            function rowClickHandler(row) {
                $state.go("main.learningItems.manageItemsTranslationsEdit", {
                    code: row.code
                });
            }
            function rowCallback(nRow, aData) {
                // Unbind first in order to avoid any duplicate handler (see https://github.com/l-lin/angular-datatables/issues/87)
                $("td", nRow).unbind("click");
                $("td:not(.checkboxControl)", nRow).bind("click", function () {
                    rowClickHandler(aData);
                });
                return nRow;
            }
            vm.dtOptions = DTOptionsBuilder.newOptions()
                .withOption("ajax", {
                url: "/api/learningItems/translation",
                error: function (error) {
                    if (error.status === 401) {
                        $state.go("main.signIn");
                    }
                    else if (error.status === 403) {
                        $state.go("main.accessDenied");
                    }
                },
                type: "GET",
                headers: {
                    Authorization: "Bearer " + authService.getToken(),
                    CurrentLocalizationId: $localStorage.currentLocalizationId
                },
                data: function (data) {
                    data.columns[1].search.value = vm.filters.itemName.enabled ? vm.filters.itemName.value : "";
                    data.columns[2].search.value = vm.filters.itemCode.enabled ? vm.filters.itemCode.value : "";
                    data.columns[3].search.value = vm.filters.itemType.enabled ? vm.filters.itemType.value.join("|") : "";
                    data.columns[4].search.value = vm.filters.needTranslation.enabled ? vm.filters.needTranslation.value.join("|") : "";
                }
            })
                .withLanguageSource("/app/i18n/datatables/" + vm.lang + ".json")
                .withDataProp("data")
                .withOption("processing", true)
                .withOption("serverSide", true)
                .withOption("responsive", { details: { type: "column" } })
                .withOption("stateSave", true)
                .withOption("stateDuration", -1)
                .withOption("rowCallback", rowCallback)
                .withOption("order", [1, "asc"])
                .withOption("createdRow", function (row, obj) {
                angular.element(row).attr("ng-class", "{selectedRow: vm.selectedRows['" + obj.id + "']['status']}");
                // Recompiling so we can bind Angular directive to the DT
                //$compile(angular.element(row))($scope);
                $compile(angular.element(row).contents())($scope);
            })
                .withOption("fnDrawCallback", function () {
                $sessionStorage.manageLearningPathsFilters = { search: vm.dtSearch, list: vm.learningPaths };
                $timeout(function () {
                    resetTheSelectedRows();
                });
            })
                .withPaginationType("full_numbers")
                .withBootstrap();
            vm.dtColumns = [
                {
                    "data": "isChecked",
                    "render": function (data, type, full) {
                        vm.selectedRows[full.id] = { 'status': false, 'item': full };
                        return "<pretty-checkbox name='checkBox' label='false' id='" + full.id + "' ng-model=vm.selectedRows['" + full.id + "']['status'] class='pretty-checkbox-table clearfix' ng-click='vm.itemChecked()'></pretty-checkbox>";
                    },
                    "sortable": false,
                    "class": "checkboxControl"
                },
                { "data": "code" },
                { "data": "name" },
                {
                    "data": "type",
                    "render": function (data) {
                        return $translate.instant(data);
                    }
                },
                {
                    "data": "indicators",
                    "render": function (data) {
                        var localizationStringBuilder = "";
                        data = _.reject(data, { localizationId: $localStorage.tenantSettings.defaultLocalization.id });
                        vm.otherLangauagesCount.push(data);
                        _.each(data, function (learningItemlocalization) {
                            if (learningItemlocalization.isTranslated) {
                                localizationStringBuilder += "<span class='learning-item-locale-indicators-translated m-b-5 m-r-5'>" + learningItemlocalization.localizationCultureName + "</span>";
                            }
                            else {
                                localizationStringBuilder += "<span class='learning-item-locale-indicators-not-translated m-b-5 m-r-5'>" + learningItemlocalization.localizationCultureName + "</span>";
                            }
                        });
                        return localizationStringBuilder;
                    }
                }
            ];
        }
    });
}());
